import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button.jsx';
import LazyImage from '../components/LazyImage.jsx';
import { TextAnimate } from '../components/ui/text-animate.jsx';
import { BlurFade } from '../components/ui/blur-fade.jsx';
import '../styles/Home.css';
import weddingClipart from '../assets/images/Clipart Wedding Invitations.png';
import birthdayClipart from '../assets/images/Clipart Birthday Invitations.png';
import christeningClipart from '../assets/images/Clipart Christening Invitations.png';
import corporateClipart from '../assets/images/Clipart Corporate Events Invitations.png';
import { 
  IoSparkles, 
  IoStar, 
  IoArrowForward,
  IoHeart,
  IoGift,
  IoCalendar
} from 'react-icons/io5';
const Home = () => {
  const services = [
    {
      title: 'Wedding Invitations',
      description: 'Elegant and romantic digital invitations for your special day',
      icon: weddingClipart,
      iconImage: true,
      link: '/invitations?category=wedding'
    },
    {
      title: 'Birthday Invitations',
      description: 'Fun and colorful designs for all ages and themes',
      icon: birthdayClipart,
      iconImage: true,
      link: '/invitations?category=birthday'
    },
    {
      title: 'Christening & Baptism',
      description: 'Beautiful and meaningful invitations for religious celebrations',
      icon: christeningClipart,
      iconImage: true,
      link: '/invitations?category=christening'
    },
    {
      title: 'Corporate Events',
      description: 'Professional designs for seminars, launches, and company events',
      icon: corporateClipart,
      iconImage: true,
      link: '/invitations?category=corporate'
    }
  ];

  const templateFeatures = [
    '✓ Choose from 12 ready-made designs',
    '✓ Personalized with your details',
    '✓ Interactive RSVP form included',
    '✓ Shareable link for easy distribution',
    '✓ Mobile-friendly responsive design',
    '✓ Fast delivery (24-48 hours)'
  ];

  const customFeatures = [
    '✓ Fully custom design from scratch',
    '✓ Up to 10 revisions',
    '✓ Unique design tailored to your theme',
    '✓ Premium animations & effects',
    '✓ Priority support & consultation',
    '✓ Fast delivery (24hrs - 3 days)'
  ];

  const testimonials = [
    {
      name: 'Maria Santos',
      event: 'Wedding Invitation',
      rating: 5,
      message: 'Sobrang ganda ng design! Lahat ng guests namin namangha sa e-invitation namin. Very professional and responsive ang Logica team. Highly recommended!',
      avatar: 'MS',
      date: '2026-03-20'
    },
    {
      name: 'John & Anna Cruz',
      event: 'Wedding Invitation',
      rating: 5,
      message: 'Best decision to go digital! The design was exactly what we wanted. Mabilis at maganda ang output. Thank you Logica Technology!',
      avatar: 'JC',
      date: '2026-03-28'
    },
    {
      name: 'Kristine Reyes',
      event: 'Birthday Invitation',
      rating: 5,
      message: 'Napakaganda ng birthday invitation ng anak ko! Ang creative at unique ng design. Will definitely order again for future events!',
      avatar: 'KR',
      date: '2026-04-02'
    },
    {
      name: 'Roberto Mendoza',
      event: 'Christening Invitation',
      rating: 5,
      message: 'Very accommodating at patient sa revisions. The final output exceeded our expectations. Affordable price for such quality work!',
      avatar: 'RM',
      date: '2026-04-05'
    },
    {
      name: 'Lovely & Mark Garcia',
      event: 'Wedding Invitation',
      rating: 5,
      message: 'Super satisfied kami! From design to final output, everything was smooth. The team really listened to what we wanted. 100% worth it!',
      avatar: 'LG',
      date: '2026-04-08'
    },
    {
      name: 'Angela Torres',
      event: 'Corporate Event',
      rating: 5,
      message: 'Professional service! Our company seminar invitation looked very elegant. Fast delivery and great communication throughout the process.',
      avatar: 'AT',
      date: '2026-04-12'
    }
  ];

  const getRelativeTime = (dateStr) => {
    const now = new Date();
    const past = new Date(dateStr);
    const diffDays = Math.floor((now - past) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return '1 day ago';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 14) return '1 week ago';
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    if (diffDays < 60) return '1 month ago';
    return `${Math.floor(diffDays / 30)} months ago`;
  };

  const hiwSteps = [
    { number: 1, icon: '📋', title: 'Book Online', desc: 'Fill out the booking form with your event details and preferred design.' },
    { number: 2, icon: '💬', title: 'We Reach Out', desc: 'Our team contacts you via Messenger within 24 hours to confirm your order.' },
    { number: 3, icon: '💳', title: '50% Downpayment', desc: 'We send payment details through Messenger. Pay 50% to get started.' },
    { number: 4, icon: '🎨', title: 'Design Creation', desc: 'We craft your personalized e-invitation based on your preferences.' },
    { number: 5, icon: '✅', title: 'Review & Approve', desc: 'Check the design. Request revisions if needed, then give your approval.' },
    { number: 6, icon: '💰', title: 'Full Payment', desc: 'Once approved, settle the remaining 50% balance to receive your final file.' },
    { number: 7, icon: '⭐', title: 'Share & Feedback', desc: 'Share your invitation with guests and leave us feedback via Messenger or tag us in your post!' },
  ];

  const hiwCardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('hiw-card--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    hiwCardsRef.current.forEach(el => { if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background-effects">
          <div className="gradient-blob blob-1"></div>
          <div className="gradient-blob blob-2"></div>
          <div className="gradient-blob blob-3"></div>
        </div>
        
        {/* Left Side - Content */}
        <div className="hero-content">
          <BlurFade delay={0.2} direction="up">
            <h1 className="hero-title">
              <span className="gradient-text">Stunning Digital</span>
              <span className="hero-subtitle">Invitations for Every Occasion</span>
            </h1>
          </BlurFade>
          <BlurFade delay={0.6} direction="up">
            <p className="hero-description">
              Make your special moments unforgettable with beautifully crafted 
              e-invitations. Perfect for weddings, birthdays, christenings, and more!
            </p>
          </BlurFade>

          <BlurFade delay={0.8} direction="up">
            <div className="hero-actions">
              <Link to="/book" className="hero-cta-link">
                <Button variant="primary" size="large" className="hero-cta-primary">
                  <span>Book Now</span>
                  <IoArrowForward className="btn-icon" />
                </Button>
              </Link>
            </div>
          </BlurFade>
        </div>

        {/* Right Side - Visual */}
        <BlurFade delay={0.4} direction="right" className="hero-visual">
          <div className="hero-image-container">
            <div className="hero-image-circle">
              <LazyImage 
                src={weddingClipart} 
                alt="Beautiful E-Invitation Design"
                effect="blur"
                threshold={300}
                priority={true}
              />
            </div>
          </div>
        </BlurFade>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="section-header">
          <h2>E-Invitation Services</h2>
          <p>Browse our collection of digital invitation designs</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <Link to={service.link} key={index} className="service-card">
              <div className="service-card-inner">
                {service.iconImage ? (
                  <div className="service-icon-wrapper">
                    <LazyImage 
                      src={service.icon} 
                      alt={service.title} 
                      className="service-icon-img"
                      effect="blur"
                      threshold={200}
                    />
                  </div>
                ) : (
                  <div className="service-icon">{service.icon}</div>
                )}
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <span className="view-samples">
                  <span>View Samples</span>
                  <IoArrowForward className="arrow-icon" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="section-header">
          <h2>How It Works</h2>
          <p>Simple steps from booking to your beautiful e-invitation</p>
        </div>
        <div className="hiw-timeline">
          {hiwSteps.map((step, index) => (
            <div
              key={index}
              className="hiw-card"
              ref={el => { hiwCardsRef.current[index] = el; }}
              style={{ '--hiw-delay': `${index * 0.09}s` }}
            >
              <div className="hiw-track">
                <div className="hiw-dot">{step.number}</div>
                {index < hiwSteps.length - 1 && <div className="hiw-connector" />}
              </div>
              <div className="hiw-card-body">
                <div className="hiw-icon-wrap">{step.icon}</div>
                <div className="hiw-text">
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="pricing">
        <div id="pricing-heading" className="section-header">
          <h2>Affordable Pricing</h2>
          <p>Quality designs that fit your budget</p>
        </div>
        <div className="pricing-grid">
          {/* Template Pricing Card */}
          <div className="pricing-card">
            <div className="pricing-header">
              <span className="pricing-type">Template Designs</span>
              <div className="pricing-amount">
                <span className="currency">₱</span>
                <span className="price">200</span>
              </div>
              <span className="pricing-note">Choose from our ready-made templates</span>
            </div>
            <div className="pricing-features">
              <h4>What's Included:</h4>
              <ul>
                {templateFeatures.map((feature, index) => (
                  <li key={index}>
                    <IoStar className="feature-icon" />
                    <span>{feature.replace('✓ ', '')}</span>
                  </li>
                ))}
              </ul>
            </div>
            <Link to="/invitations">
              <Button variant="outline-primary" size="large" className="pricing-btn">
                Browse Templates
              </Button>
            </Link>
          </div>

          {/* Custom Design Pricing Card */}
          <div className="pricing-card featured">
            <div className="pricing-badge">
              <IoSparkles className="badge-icon-small" />
              <span>Most Popular</span>
            </div>
            <div className="pricing-header">
              <span className="pricing-type">Custom Designs</span>
              <div className="pricing-amount">
                <span className="currency">₱</span>
                <span className="price">350</span>
                <span className="price-range-sep">–</span>
                <span className="currency">₱</span>
                <span className="price">700</span>
              </div>
              <span className="pricing-note">Unique design made just for you</span>
            </div>
            <div className="pricing-features">
              <h4>What's Included:</h4>
              <ul>
                {customFeatures.map((feature, index) => (
                  <li key={index}>
                    <IoStar className="feature-icon" />
                    <span>{feature.replace('✓ ', '')}</span>
                  </li>
                ))}
              </ul>
            </div>
            <Link to="/book">
              <Button variant="primary" size="large" className="pricing-btn">
                Book Custom Design
              </Button>
            </Link>
          </div>
        </div>

        <div className="payment-terms-note">
          <span className="payment-terms-icon">💳</span>
          <div>
            <strong>Payment Terms:</strong> 50% downpayment upon booking. Remaining 50% is due once the design is completed and approved by the client.
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="testimonials-header">
          <div className="testimonials-header-left">
            <h2>Why Say Our Client</h2>
            <p>See what our clients say about their experience with us. Trusted for quality, comfort and, and seamless transfers every time!</p>
          </div>
        </div>
        <div className="testimonials-container">
          <div className="testimonials-grid">
            {testimonials.slice(0, 3).map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-rating">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <IoStar key={i} className="star-icon" />
                  ))}
                </div>
                <p className="testimonial-message">{testimonial.message}</p>
                <div className="testimonial-footer">
                  <div className="testimonial-user">
                    <div className="testimonial-avatar">{testimonial.avatar}</div>
                    <div className="testimonial-info">
                      <h4>{testimonial.name}</h4>
                      <span className="testimonial-time">{getRelativeTime(testimonial.date)}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="cta-background-pattern"></div>
        <div className="cta-container">
          <div className="cta-content-left">
        
            <h2>Ready to Create Your Digital Invitation?</h2>
            <p>Take the next step toward transforming your special events. With our beautifully designed e-invitations, share your joy with guests in style and stand out from traditional paper cards.</p>
            <div className="cta-actions">
              <Link to="/book">
                <Button variant="primary" size="large" className="cta-btn-primary">
                  <span>Get started now</span>
                  <IoArrowForward className="btn-icon" />
                </Button>
              </Link>
              <Link to="/invitations">
                <Button variant="outline" size="large" className="cta-btn-secondary">
                  Try demo for free
                </Button>
              </Link>
            </div>
          </div>
          <div className="cta-content-right">
            <div className="cta-phone-mockup">
              <div className="phone-frame">
                <div className="phone-notch"></div>
                <div className="phone-screen">
                  <div className="phone-status-bar">
                    <span className="status-time">1:47</span>
                    <div className="status-icons">
                      <div className="status-signal"></div>
                      <div className="status-wifi"></div>
                      <div className="status-battery"></div>
                    </div>
                  </div>
                  <div className="phone-content">
                    <div className="invitation-preview">
                      <div className="invitation-header">
                        <IoHeart className="invitation-icon" />
                        <h3>Wedding Invitation</h3>
                      </div>
                      <div className="invitation-card">
                        <LazyImage 
                          src={weddingClipart} 
                          alt="Invitation Preview" 
                          className="invitation-image"
                          effect="blur"
                          threshold={200}
                        />
                        <div className="invitation-details">
                          <h4>John & Sarah</h4>
                          <p>You're invited to our special day!</p>
                          <div className="invitation-date">
                            <IoCalendar className="date-icon" />
                            <span>June 15, 2026</span>
                          </div>
                        </div>
                      </div>
                      <button className="rsvp-button">
                        <span>RSVP Now</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
